import { IDownloadSoftwareModel } from './download-software.interface';

export const CONSOLE_GROUPS_DATA: IDownloadSoftwareModel[] = [
  {
    displayOrder: 1,
    consoleGroup: 'SE4',
    consoleTypes: [
      {
        consoleType: 'everest',
        displayName: 'Symbio',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_EVEREST_210x150.png',
      },
      {
        consoleType: 'hal',
        displayName: 'SE4',
        productName: 'Life Fitness',
        displayOrder: 2,
        image: 'Console_HAL_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
    isFullLength: true,
  },
  {
    displayOrder: 2,
    consoleGroup: 'SE3',
    consoleTypes: [
      {
        consoleType: 'superman',
        displayName: 'Discover SE3 HD',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_SUPERMAN_210x150.png',
      },
      {
        consoleType: 'aquaman',
        displayName: 'Discover SE3',
        productName: 'Life Fitness',
        displayOrder: 2,
        image: 'Console_AQUAMAN_210x150.png',
      },
      {
        consoleType: 'bluth',
        displayName: 'Discover ST',
        productName: 'Life Fitness',
        displayOrder: 3,
        image: 'Console_BLUTH_210x150.png',
      },
      {
        consoleType: 'mulder',
        displayName: '70T',
        productName: 'Cybex',
        displayOrder: 4,
        image: 'Console_MULDER_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
    isFullLength: true,
  },
  {
    displayOrder: 3,
    consoleGroup: 'Integrity_SL',
    consoleTypes: [
      {
        consoleType: 'batman',
        displayName: 'SL',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_BATMAN_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
  {
    displayOrder: 4,
    consoleGroup: 'Duplo_C',
    consoleTypes: [
      {
        consoleType: 'duplo',
        displayName: 'C',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_DUPLO_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
  {
    displayOrder: 5,
    consoleGroup: 'Integrity_X',
    consoleTypes: [
      {
        consoleType: 'hercules',
        displayName: 'X',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_HERCULES_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
  {
    displayOrder: 6,
    consoleGroup: '50L',
    consoleTypes: [
      {
        consoleType: 't1',
        displayName: '50L',
        productName: 'Cybex',
        displayOrder: 1,
        image: 'Console_T1_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
  {
    displayOrder: 7,
    consoleGroup: 'Discover',
    consoleTypes: [
      {
        consoleType: 'discover',
        displayName: 'Discover SE/SI',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_DISCOVER_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
  {
    displayOrder: 8,
    consoleGroup: 'Explorer',
    consoleTypes: [
      {
        consoleType: 'explorer',
        displayName: 'Explore',
        productName: 'Life Fitness',
        displayOrder: 1,
        image: 'Console_ZEUS_210x150.png',
      },
    ],
    officialSoftware: {
      version: '',
      url: '',
    },
  },
];
